import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import type { NumberInputProps } from 'components/common/input-components/number-input';
import NumberInput from 'components/common/input-components/number-input';

const ControlledNumberInput = withLabel(withController<NumberInputProps>(NumberInput, { withoutRef: true }));
export default ControlledNumberInput;
